export default __webpack_public_path__ + "static/media/Tea.b92bedea.jpg";